import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { usePublicDataClient } from '@juvare/platform-sdk-react/ui/hooks';
import { usePlatformSdkReactTranslation } from '@juvare/platform-sdk-react/ui/hooks/usePlatformSdkReactTranslation';

export const useStateAndTerritoryOrEmptyArrayValueProvider = (): ValueProvider => {
    const { t } = usePlatformSdkReactTranslation();
    const publicDataClient = usePublicDataClient();
    return {
        type: 'stateAndTerritoryOrEmptyArray',
        label: t('defaultClassifiers.stateAndTerritory'),
        getValues: (params) => {
            const shouldReturnEmptyArray = typeof params === 'boolean' && params;
            if (shouldReturnEmptyArray) {
                return Promise.resolve([]);
            }
            return publicDataClient.publicDataGetObject('classifier-stateAndTerritory');
        },
    };
};
